import { compose } from 'ramda';

import { ascii, trim } from 'yafrpl/strings';

export const formatId = compose(
  (str) => str.replace(/\W/g, '').toLowerCase(),
  ascii,
  trim
);
